import * as TYPES from './_types';
import moment from 'moment';

//Reducer
const INITIAL_STATE = {
  channels: {
    emails: [],
    devices: []
  },
  integrations: [],
  activities: {
    data: [],
    page: 1,
    total_pages: 1,
    total: 0,
    search: '',
    sort_by: 'created_at',
    sort_order: 'desc',
    from: moment()
      .subtract(30, 'days')
      .format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
    integrations: []
  }
};

export default function channels(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TYPES.FETCH_CHANNELS:
      return {
        ...state
      };

    case TYPES.FETCH_CHANNELS_SUCCESS:
      const { channels } = action.payload;
      return {
        ...state,
        channels
      };

    case TYPES.FETCH_CHANNELS_FAILURE:
      return {
        ...state
      };

    case TYPES.FETCH_CHANNEL_ACTIVITY:
      const { search, sort_by, sort_order, from, to, page, integrations } = action.payload;

      return {
        ...state,
        activities: {
          ...state.activities,
          page,
          to,
          from,
          sort_by,
          sort_order,
          search,
          integrations
        }
      };

    case TYPES.FETCH_CHANNELS_ACTIVITY_SUCCESS:
      const { data, total_pages, total } = action.payload.activities;
      return {
        ...state,
        activities: {
          ...state.activities,
          data,
          total_pages,
          total
        }
      };

    case TYPES.FETCH_CHANNELS_ACTIVITY_FAILURE:
      return {
        ...state
      };

    case TYPES.FETCH_INTEGRATIONS:
      return {
        ...state
      };
    case TYPES.FETCH_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        integrations: action.payload.integrations
      };

    case TYPES.FETCH_INTEGRATIONS:
      return {
        ...state
      };

    case TYPES.UPDATE_CHANNEL_EMAIL_SUCCESS:
      let emails = [...state.channels.emails];
      emails[emails.findIndex(f => f.id == action.payload.id)]['alias'] = action.payload.alias;
      return {
        ...state,
        channels: {
          ...state.channels,
          emails: emails
        }
      };

    case TYPES.UPDATE_CHANNEL_DEVICE_SUCCESS:
      let devices = [...state.channels.devices];
      devices[devices.findIndex(f => f._id == action.payload._id)]['alias'] = action.payload.alias;
      return {
        ...state,
        channels: {
          ...state.channels,
          devices: devices
        }
      };

    case TYPES.UNTRUST_DEVICE_SUCCESS:
      return {
        ...state,
        channels: {
          ...state.channels,
          devices: state.channels.devices.map(d =>
            d._id === action.payload.device._id ? action.payload.device : d
          )
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/views/channels/_reducer.js